import { useContext, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/useAppDispatchSelector';
import { ReactComponent as DownIcon } from 'assets/icon/chevron-down.svg';
import { logout, setSelectedAuthOrganization } from 'store/features/authSlice';
import { useNavigate } from 'react-router-dom';
import { camelCase, capitalize, formatText, usersRoles } from 'helpers/utils';
import NamePlaceholderImage from 'components/common/placeholder-image';
import { AppContext } from 'context/app-context';
import { setItemInLocalStorage } from 'helpers/localstorage';
import { IAuthOrganizations } from 'interfaces/auth-pages-interfaces';
import { useTranslation } from 'react-i18next';

const ProfileBox = () => {
  const { setLoader } = useContext(AppContext);
  const { user, selectedOrganization } = useAppSelector(state => state.auth);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [showOption, setShowOption] = useState<boolean>(false);
  const [showOrgList, setShowOrgList] = useState<boolean>(false);

  const { t } = useTranslation();

  const onBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setShowOption(false);
      setShowOrgList(false);
    }
  };

  const handleLogout = async () => {
    setLoader(true);
    await dispatch(logout());
    // await removeGoogleTranslatorScript();
    setLoader(false);
    // window.location.reload();
  };

  const handleSwitchOrganization = (data: IAuthOrganizations) => {
    try {
      setItemInLocalStorage('org', data);
      dispatch(setSelectedAuthOrganization(data));
    } catch (error) {}
  };
  return (
    <div
      className={`flex h-[46px] w-auto md:w-[400px] max-w-[400px] gap-x-4  ${
        selectedOrganization?.role_name === usersRoles?.SUPER_ADMIN ||
        selectedOrganization?.role_name === usersRoles?.FLEET_MANAGE
          ? ''
          : 'cursor-pointer'
      } justify-end`}
      onBlur={onBlur}
    >
      <div className="flex items-center gap-x-1 relative w-full ">
        <div
          className="flex items-center px-3 border-r-2 relative w-1/2 max-w-[160px]"
          onClick={() => {
            setShowOrgList(!showOrgList);
          }}
          onBlur={e => {
            e.preventDefault();
            if (!e.currentTarget.contains(e.relatedTarget)) {
              setShowOrgList(false);
            }
          }}
          tabIndex={0}
        >
          <div className="flex flex-col items-end justify-end flex-1 overflow-hidden ">
            <p className="font-medium text-sm text-end whitespace-nowrap w-full overflow-hidden text-ellipsis">
              {selectedOrganization?.role_name === usersRoles.FLEET_MANAGE
                ? t('COMPANY')
                : t('ORG')}
            </p>
            <p className="font-regular text-grey7 text-xs text-end whitespace-nowrap w-full overflow-hidden text-ellipsis">
              {selectedOrganization?.role_name === usersRoles.SUPER_ADMIN
                ? 'Dealerbest'
                : selectedOrganization?.role_name === usersRoles.FLEET_MANAGE
                ? selectedOrganization?.company_name
                : selectedOrganization?.organization_name}
            </p>
          </div>
          {selectedOrganization?.role_name === usersRoles?.FLEET_MANAGE ||
          selectedOrganization?.role_name === usersRoles?.SUPER_ADMIN ? (
            <></>
          ) : (
            <div className="flex items-center gap-x-2.5 ml-3">
              <DownIcon className="flex items-center justify-center" height={20} width={20} />
            </div>
          )}
          {selectedOrganization?.role_name === usersRoles?.SUPER_ADMIN ||
          selectedOrganization?.role_name === usersRoles?.FLEET_MANAGE ? (
            <></>
          ) : showOrgList ? (
            <div className="flex flex-col absolute menu-wrapper top-11 py-2 w-full max-w-[250px] rounded-1 border-1.5 border-divider max-h-40 box-border z-10 bg-white shadow-md overflow-hidden">
              <div className="flex flex-col h-full overflow-y-auto">
                {user?.login_details.map(data => (
                  <div
                    className={`flex items-center px-4 py-2 gap-x-2 w-full hover:bg-grey8 ${
                      selectedOrganization?.role_name === usersRoles?.SUPER_ADMIN ||
                      selectedOrganization?.role_name === usersRoles?.FLEET_MANAGE
                        ? ''
                        : 'cursor-pointer'
                    }`}
                    onClick={() => handleSwitchOrganization(data)}
                    title={data?.organization_name}
                  >
                    <label className="text-sm font-medium text-black1 flex-1 cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis">
                      {data?.organization_name}
                    </label>
                    {data?.organization_id === selectedOrganization?.organization_id && (
                      <div className={`flex items-center px-3 rounded-full bg-successBG}`}>
                        <label
                          className={`text-sm flex-1 text-ellipsis whitespace-nowrap overflow-hidden text-success`}
                        >
                          {t('ACTIVE')}
                        </label>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
        <div
          className="flex items-center w-[240px] relative max-w-[240px] cursor-pointer"
          onClick={() => setShowOption(!showOption)}
          onBlur={e => {
            e.preventDefault();
            if (!e.currentTarget.contains(e.relatedTarget)) {
              setShowOption(false);
            }
          }}
          tabIndex={0}
        >
          <div className="overflow-hidden md:flex flex-col flex-1 px-3">
            <p className="font-medium text-sm text-end whitespace-nowrap w-full overflow-hidden text-ellipsis">
              {user?.user_details?.name && user?.user_details?.surname
                ? `${user?.user_details?.name} ${user?.user_details?.surname}`
                : ''}
            </p>
            <p className="font-regular text-grey7 text-xs text-end whitespace-nowrap w-full overflow-hidden text-ellipsis">
              {capitalize(camelCase(formatText(selectedOrganization?.role_name, ' ')))}
            </p>
          </div>
          <div className="flex items-center gap-x-1 ml-1">
            {/* <ProfileImage className="flex rounded-full" /> */}
            <NamePlaceholderImage
              name={
                user?.user_details?.name && user?.user_details?.surname
                  ? `${user?.user_details?.name} ${user?.user_details?.surname}`
                  : ''
              }
            />
            <DownIcon className="flex items-center justify-center" height={20} width={20} />
          </div>
          {showOption && (
            <div className="flex flex-col absolute menu-wrapper top-11 py-2 rounded-1 border-1.5 border-divider min-w-[230px] left-0 ">
              <div
                className="flex items-center px-4 py-2 gap-x-2 w-full hover:bg-grey8 cursor-pointer"
                onClick={() => navigate('/profile')}
              >
                <label className="text-sm font-medium text-black1 flex-1 cursor-pointer">
                  {t('PROFILE')}
                </label>
              </div>
              <div
                className="flex items-center px-4 py-2 gap-x-2 w-full hover:bg-grey8 cursor-pointer"
                onClick={handleLogout}
              >
                <label className="text-sm font-medium text-black1 flex-1 cursor-pointer">
                  {t('LOGOUT')}
                </label>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileBox;
